<template>
  <el-container>
    <el-aside width="200px"></el-aside>
    <el-main>
      <el-card class="card">
        <template v-slot:header>
          <div class="clearfix">
            <span style="font-weight: bold;"><i class="el-icon-s-order" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>Motif Result</span>
            <el-button type="primary" icon="el-icon-download" size="medium" @click="exportCsv" style="float: right;background-color: #2C3E50;border: 1px solid #2C3E50;">Download</el-button>
          </div>
        </template>
        <div>
          <el-table :data="paginationData" border style="width:100%;color:black;" empty-text="No data available." fit>
            <el-table-column prop="Motif Name" label="Motif"></el-table-column>
            <el-table-column prop="convert" label="Sequence"></el-table-column>
          </el-table>
          <el-pagination
            style="margin-top: 20px; text-align: center;"
            :current-page="currentPage"
            :page-size="pageSize"
            :total="tableData.length"
            :background="true"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </el-card>
    </el-main>
    <el-aside width="200px"></el-aside>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.tableData.length / this.pageSize);
    },
    paginationData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.tableData.slice(start, end);
    },
  },
  mounted() {
    this.tableData = this.$route.params.res.result_data;
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    exportCsv() {
      const header = ['Motif', 'Sequence'];
      const data = this.tableData.map(row => ({
        Motif: row['Motif Name'],
        Sequence: row.convert
      }));
      const csv = [
        header.join(','),
        ...data.map(row => Object.values(row).join(','))
      ].join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'Motif.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped>
.card {
  margin-top: 60px;
  margin-bottom: 30px;
  border-color: #010c0c;
}
.clearfix{
  font-size: larger;
}
</style>



// WEBPACK FOOTER //
// src/components/Convertmotif/Motiflist.vue